import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
  const token = localStorage.getItem('username'); // Verifica se há um token de usuário

  // Se não estiver autenticado, redireciona para a página inicial
  if (!isAuthenticated || !token) {
    return <Navigate to="/" replace />;
  }

  // Se autenticado, renderiza o componente filho
  return children;
};

export default ProtectedRoute;
